import Entrada from "./Entrada";

export default class EntradaItem {
  constructor(id, codigo, nome, quantidade) {
    this.id = id;
    this.codigo = codigo;
    this.nome = nome;
    this.quantidade = quantidade;
    this.entrada = new Entrada(0, "", "", new Date(), "", "", "", false);
  }

  update(item) {
    this.id = item.id;
    this.codigo = item.codigo;
    this.nome = item.nome;
    this.quantidade = item.quantidade;
    this.entrada = item.entrada;
  }
}
